import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '@via/services';
import { lastValueFrom } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

import {
  ChangeTenantRequest,
  ClientDetails,
  ClientsAllDetails,
  CreateViaAdminClient,
  EditViaAdminClient,
} from './pages/client-management/client.model';
import {
  CreateTenant,
  TenantDetails,
} from './pages/tenant-management/tenants/tenant.model';

@Injectable({
  providedIn: 'root',
})
export class AdminApiService {
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private commonService: CommonService
  ) {}

  getClient() {
    return this.apiService.get<ClientDetails[]>('viaiam/api/client/all');
  }

  getTenantClient(tenantId: string) {
    return this.apiService.get<ClientDetails[]>(
      `viaiam/api/client/tenant/${tenantId}`
    );
  }

  createVIAAdminClient(payload: CreateViaAdminClient) {
    return this.apiService.post('viaiam/api/client/create', payload);
  }

  createTenantAdminClient(payload: number) {
    return this.apiService.post('viaiam/api/tenantServicers/create', payload);
  }

  editViaAdminClient(payload: EditViaAdminClient) {
    return this.apiService.put('viaiam/api/client/edit', payload);
  }

  getTenantList() {
    return this.apiService.get<TenantDetails[]>('viaiam/api/tenant/all');
  }

  createTenant(payload: CreateTenant) {
    return this.apiService.post('viaiam/api/tenant/create', payload);
  }

  editTenant(payload: TenantDetails) {
    return this.apiService.put('viaiam/api/tenant/edit', payload);
  }

  changeCurrentTenant(payload: ChangeTenantRequest) {
    return this.apiService.post<number>('viaiam/api/tenant/change', payload);
  }

  getCityStateLookup(postalCode: string) {
    return lastValueFrom(
      this.http.get(`https://api.zippopotam.us/us/${postalCode}`)
    ).catch(() =>
      this.commonService.showToast('Error', 'Zip code details not found')
    ) as Promise<any>;
  }

  getAllClients() {
    return this.apiService.get<ClientsAllDetails[]>(`viacore/api/clients/all`);
  }

  createClient(payload: ClientsAllDetails) {
    return this.apiService.post('viacore/api/client', payload);
  }

  updateClient(payload: ClientsAllDetails) {
    return this.apiService.put('viacore/api/client', payload);
  }

  changeClientStatus(clientId: number) {
    return this.apiService.post('viacore/api/client/changestatus', clientId);
  }

  getClientDetailsById(clientId: number) {
    return this.apiService.get<ClientsAllDetails>(
      `viacore/api/client/${clientId}`
    );
  }
}
